import { useMediaQuery, Box, Drawer } from '@mui/material';
import SidebarItems from './SidebarItems';
import Logo from '../../components/Logo';

interface Props {
  isSidebarOpen: boolean
  isMobileSidebarOpen: boolean
  onSidebarClose: () => void
}

const Sidebar = ({ isSidebarOpen, isMobileSidebarOpen, onSidebarClose }: Props) => {

  const lgUp = useMediaQuery((theme: any) => theme.breakpoints.up("lg"));
  const sidebarWidth = '400px';

  if (lgUp) {
    return (
      <Box
        sx={{
          backgroundColor: "#001B2F",
          width: sidebarWidth,
          flexShrink: 0,
        }}
      >
        {/* ------------------------------------------- */}
        {/* Sidebar for desktop */}
        {/* ------------------------------------------- */}
        <Drawer
          anchor="left"
          open={isSidebarOpen}
          variant="permanent"
          PaperProps={{
            sx: {
              width: sidebarWidth,
              boxSizing: 'border-box',
              backgroundColor: "#001B2F",
            },
          }}
        >
          {/* ------------------------------------------- */}
          {/* Sidebar Box */}
          {/* ------------------------------------------- */}
          <Box 
            sx={{ 
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyItems: "center",
            }}>
            {/* ------------------------------------------- */}
            {/* Logo */}
            {/* ------------------------------------------- */}
            <Box pt={5}>
              <Logo imgH={50} nameH={37} row={true} />
            </Box>
    
            <Box sx={{ pt: 5 }}>
              {/* ------------------------------------------- */}
              {/* Sidebar Items */}
              {/* ------------------------------------------- */}
              <SidebarItems />
            </Box>

          </Box>
        </Drawer>
      </Box>
    )
  }

  return (
    <Drawer
      anchor="left"
      open={isMobileSidebarOpen}
      onClose={onSidebarClose}
      variant="temporary"
      PaperProps={{
        sx: {
          backgroundColor: "#001B2F",
          width: sidebarWidth,
          boxShadow: (theme) => theme.shadows[8],
        },
      }}
    >
      {/* ------------------------------------------- */}
      {/* Sidebar For Mobile */}
      {/* ------------------------------------------- */}
          <Box 
            sx={{ 
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyItems: "center",
              // justifyContent: "space-between",
            }}>

            {/* ------------------------------------------- */}
            {/* Logo */}
            {/* ------------------------------------------- */}
            <Box>
              <Logo imgH={50} nameH={37} row={true} />
            </Box>
      
            <Box sx={{ pt: 5 }}>
              {/* ------------------------------------------- */}
              {/* Sidebar Items */}
              {/* ------------------------------------------- */}
              <SidebarItems />
            </Box>
          </Box>
    </Drawer>
  );
}

export default Sidebar